import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
const Post = ({post, postId}) => {
  var like = 0;
    useEffect(()=>{
        console.log(postId)
    }, [])
    const ps = post.post
    const getPost = () =>{

    }
  return (
    <Link to={`../page/${ps.uuid}`}  style={{ 'textDecoration':'none'}}>
      <div class={`post ${ps.status}`}>
        <div className="details">
          <div class={`status ${ps.status=="Fixed" ? "fText" : "uText"}`}>{ps.status}</div>
          <h2>{ps.title}</h2>
          <div class="tags">
            {ps.tags.map((tag)=>(
              <div class="tag">{tag}</div>
            ))}
          </div>
          <h4>{ps.caption}</h4>
        </div>
        <div class="rating">
          <FontAwesomeIcon className="thumbs" icon={faThumbsUp} />
          <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {ps.up - ps.down}
          </div>
          <FontAwesomeIcon className="thumbs" icon={faThumbsDown} />
        </div>
      </div>
    </Link>
  );
};

export default Post;
